module.exports = __webpack_public_path__ + "static/in_situ-3e2aa20ddd75adf32a557dcab33b4b10.png";